import React from 'react';
import styled from 'styled-components';
import appInfoContainer from '../../auth/appInfoContainer';
import { Link } from "react-router-dom";


export default function ChatingDetail({value ,isSelf ,isStart ,isTime ,isDateChange}) {
    //날짜 출력 폼 형태 시간 포함
    function getDateTimeType(date, second){
        function checkZero(checkString){
        return checkString.toString().length === 1 ?  "0" + checkString : checkString;
        }
        var temp = 
            // `${checkZero(date.getFullYear())}-${checkZero(date.getMonth() + 1)}-${checkZero(date.getDate())}` +
            ` ${checkZero(date.getHours())}:${checkZero(date.getMinutes())} ${second ? ":" + checkZero(date.getSeconds()) : ""} `;
        return temp;
    }

    function getDate(date){
        function checkZero(checkString){
        return checkString.toString().length === 1 ?  "0" + checkString : checkString;
        }
        var temp = `${checkZero(date.getFullYear())}. ${checkZero(date.getMonth() + 1)}. ${checkZero(date.getDate())}` 
        return temp;
    }

    return(
        <ChatingDetailinner>
            <div>
                {
                    isSelf  ? 
                    <ChatingBox>
                      <ChatZoneright>
                            <CahtboxrightLast>
                            {
                                isTime ?
                                <ChatTimeR>{getDateTimeType(value.create_date ? new Date(value.create_date) : new Date(),false)}</ChatTimeR>
                                :
                                null
                            }
                            {
                            isStart ?
                                <Cahtboxrightstart>{value.content}</Cahtboxrightstart>
                                :
                                <Cahtboxright>{value.content}</Cahtboxright>
                            }
                            </CahtboxrightLast>
                      </ChatZoneright>
                    </ChatingBox>
                    :
                    <div>
                    {
                        isStart ?
                        <User>
                            <Link component={Userimg} to={`/task/friend/${value.user_no}/list`}><Images src={appInfoContainer.imagePath +"/user_profile_img/"+value.profile_img}/></Link>
                            <Username>{value.nickname}</Username>
                        </User>
                        :
                        null
                    }
                    <ChatingBox>
                        <ChatZoneleft>
                            <CahtboxleftLast>
                            {
                                    isStart ? 
                                    <Cahtboxleftstart>{value.content}</Cahtboxleftstart>
                                    :
                                    <Cahtboxleft>{value.content}</Cahtboxleft>
                            }
                            {
                                isTime ?
                                <ChatTime>{getDateTimeType(value.create_date ? new Date(value.create_date) : new Date(),false)}</ChatTime>
                                :
                                null
                            }
                            </CahtboxleftLast>
                        </ChatZoneleft>
                    </ChatingBox>
                    </div>
                }
                {/* 날짜 라인  */}
                {
                    isDateChange ?
                    <DayLine>{getDate(new Date(value.modify_date))}</DayLine>
                    :
                    null
                }
                


            </div>
        </ChatingDetailinner>
    )
}

const Images = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`

const ChatingDetailinner = styled.div`
    padding: calc(100vw*(10.5/375)) calc(100vw*(25/375)) calc(100vw*(10/375)) calc(100vw*(16/375));
`
const User = styled.h1`
    display: flex;
    align-items: center;
`
const Userimg = styled.a`
    width: calc(100vw*(40/375));
    height: calc(100vw*(40/375));
    border-radius: 50%;
    overflow:hidden;
    border: solid calc(100vw*(1/375)) #c6c6c6;
`
const Username = styled.p` 
    font-size: calc(100vw*(14/375));;
    font-weight: bold;
    margin-left : calc(100vw*(8/375));
`
const ChatingBox = styled.div`
    margin-top: calc(100vw*(-11/375));
`
const ChatZoneleft = styled.div`
    margin-left: calc(100vw*(48/375));
`
const ChatZoneright = styled(ChatZoneleft)`
    margin-left: calc(100vw*(48/375));
    text-align: right;
    // padding-top: calc(100vw*(17/375));
`
// 채팅말풍선
// 챗팅 왼쪽 말풍선
const Cahtboxleft = styled.div`
    border: solid 1px #eaeaea;
    background-color: #ffffff;
    padding : calc(100vw*(5/375))  calc(100vw*(15/375))  calc(100vw*(9/375))  calc(100vw*(11/375));
    border-radius: calc(100vw*(17/375)) ;
    border: solid calc(100vw*(1/375)) #eaeaea;
    background-color: #ffffff;
    display:inline-block;
    // margin-bottom : calc(100vw*(6/375));
    font-size: calc(100vw*(14/375));
    white-space: pre-wrap;
    text-align :left;
    word-break: break-all;
`
// 채팅 말풍선 시작
const Cahtboxleftstart = styled(Cahtboxleft)`
    border-radius: 0 calc(100vw*(17/375)) calc(100vw*(17/375)) calc(100vw*(17/375)) ;
    
    text-align :left;
    word-break: break-all;
`
// 채팅 말풍선 마지막
const CahtboxleftLast = styled.div`
    display: flex;
    align-items: flex-end;
`
const ChatTime = styled.span`
    display: inline-block;
    // margin-bottom: calc(100vw*(9/375));
    margin-left : calc(100vw*(5/375));
    font-size: calc(100vw*(10/375));
    line-height: 1.5;
    color: #7f7f7f;
`

// 챗팅 외른쪽 말풍선

// 채팅 말풍선 시작
const Cahtboxrightstart = styled(Cahtboxleft)`
    border-radius:  calc(100vw*(17/375))  0 calc(100vw*(17/375)) calc(100vw*(17/375)) ; 
    background-color: #ffefce;
    white-space: pre-wrap;
    
    text-align :left;
    word-break: break-all;
`
const ChatTimeR = styled(ChatTime)`
    margin-right : calc(100vw*(5/375));
`
const Cahtboxright = styled(Cahtboxleft)`
    background-color: #ffefce;
    
    text-align :left;
    word-break: break-all;
`
const DayLine = styled.span`
    position: relative;
    display: block;
    width: 100%;
    text-align: center;
    font-size:  calc(100vw*(11/375));
    line-height: 1.55;
    color: #989898;
    margin-top: calc(100vw*(21/375));

    &::before {
        content:'';
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: calc(100vw*(105/375));
        height : calc(100vw*(1/375));
        background:#d5d5d5;
    }
    &::after {
        content:'';
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        width: calc(100vw*(105/375));
        height : calc(100vw*(1/375));
        background:#d5d5d5;
    }
`
const CahtboxrightLast = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
`